import { Injectable } from '@angular/core';
import { BankEndPoints, BankIncomeEndPoints, BankExpensesEndPoints } from '../../../../app/constants/api-endpoints';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Bank } from '../../../models/bank/bank-model';
import { map } from 'rxjs/operators';
import { BankIncome } from '../../../models/bank/bank-income-model';
import { BankExtraction } from '../../../models/bank/bank-extraction-model';
import { ApiService } from '../../common/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class BankService {

  bankUrls = BankEndPoints;
  bankIncomeUrls = BankIncomeEndPoints;
  bankExpensesUrls = BankExpensesEndPoints;

  constructor(private _apiService : ApiService) {
  }

  private returnResponse(response) {
    if (response._statusCode > 399) {
      throw (response);
    }
    return response;
  }

  getBankById(id: number): Observable<Bank> {
    return this._apiService.get(this.bankUrls.getBankById + id, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getBankList(): Observable<Bank[]> {
    return this._apiService.get(this.bankUrls.getBankList, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getBankDropDownList(): Observable<Bank> {
    return this._apiService.get(this.bankUrls.getBankDropDownList, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  saveBank(bank: Bank): Observable<Bank> {
    return this._apiService.post(this.bankUrls.saveBank, bank, true, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  updateBank(id: number, bank: Bank): Observable<Bank> {
    return this._apiService.put(this.bankUrls.updateBank + id, bank, true, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  deleteBank(id: number): Observable<Bank> {
    return this._apiService.delete(this.bankUrls.deleteBank, id.toString(), true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getBanKIncomeList(): Observable<BankIncome> {
    return this._apiService.get(this.bankIncomeUrls.getBanKIncomeList, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  saveBankIncome(bankIncome: BankIncome): Observable<BankIncome> {
    return this._apiService.post(this.bankIncomeUrls.saveBankIncome, bankIncome, true, true).pipe(
       map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  updateBankIncome(id: number, bankIncome: BankIncome): Observable<BankIncome> {
    return this._apiService.put(this.bankIncomeUrls.updateBankIncome + id, bankIncome, true, true).pipe(
        map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  deleteBankIncome(id: number): Observable<BankIncome> {
    return this._apiService.delete(this.bankIncomeUrls.deleteBankIncome, id.toString(), true).pipe(
         map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getBankIncomeListWithPagination(pageSize: number, page: number, incomeDate: string, amount: string, concept: string, bankId: string,endDate: string):
    Observable<BankIncome> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('filter', incomeDate + ',' + amount + ',' + concept + ',' + bankId + ',' + endDate);

      const query = params.toString().replace('+', '%20');

    return this._apiService.get(this.bankIncomeUrls.getBankIncomeListWithPagination + '?' + `${query}`, true).pipe(
       map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getBankListWithPagination(pageSize: number, page: number, searchText: string): Observable<Bank> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('filter', searchText);
      const query = params.toString().replace('+', '%20');

      return this._apiService.get(this.bankUrls.getBankListWithPagination + '?' + `${query}`, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getBankExpensesList(): Observable<BankExtraction> {
    return this._apiService.get(this.bankExpensesUrls.getBankExtractionList, true).pipe(
       map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  saveBankExpenses(bankExtraction: BankExtraction): Observable<BankExtraction> {
    return this._apiService.post(this.bankExpensesUrls.saveBankExtraction, bankExtraction, true, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  updateBankExpenses(_id: number, bankExtraction: BankExtraction): Observable<BankIncome> {
    return this._apiService.put(this.bankExpensesUrls.updateBankExtraction, bankExtraction, true, true).pipe(
      map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  deleteBankExpenses(id: number): Observable<BankExtraction> {
    return this._apiService.delete(this.bankExpensesUrls.deleteBankExtraction, id.toString(), true).pipe(
           map((response: any) => {
        return this.returnResponse(response);
      }));
  }

  getBankExpensesListWithPagination(pageSize: number, page: number, incomeDate: string, amount: string, concept: string, bankId: string,endDate:string):
    Observable<BankExtraction> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('filter', incomeDate + ',' + amount + ',' + concept + ',' + bankId + ',' + endDate);

      const query = params.toString().replace('+', '%20');

    return this._apiService.get(this.bankExpensesUrls.getBankExtractionListWithPagination + '?' + `${query}`, true).pipe(
       map((response: any) => {
        return this.returnResponse(response);
      }));
  }
}
